import { AssessmentType } from "types/graphql-schema";
import { BasicUser } from "types/topicflow";

import AssessmentQuestionStackedTextAnswers from "../assessment-question-stacked-text-answers";
import QuestionContextButton from "./question-context-button";
import TextAssessmentQuestionContent from "./text-assessment-question-content";
import { AssessmentAnswer } from "./types";

const TextQuestionForm = ({
  formDisabled,
  answer,
  onUpdateAnswer,
  questionId,
  responseItems,
  assessmentType,
}: {
  formDisabled: boolean;
  answer?: AssessmentAnswer | null;
  onUpdateAnswer: (newAnswer: Partial<AssessmentAnswer>) => void;
  questionId: number;
  responseItems: {
    responder?: BasicUser | null;
    text?: string | null;
  }[];
  assessmentType: AssessmentType;
}) => {
  return (
    <>
      <TextAssessmentQuestionContent
        disabled={formDisabled}
        answer={answer}
        onChangeAnswer={onUpdateAnswer}
      />
      <QuestionContextButton
        questionId={questionId}
        assessmentType={assessmentType}
      />
      {responseItems.length > 0 &&
        assessmentType === AssessmentType.Performance && (
          <div className="mt-4">
            <AssessmentQuestionStackedTextAnswers
              questionId={questionId}
              answers={responseItems}
            />
          </div>
        )}
    </>
  );
};

export default TextQuestionForm;
